/* eslint-disable max-len */
import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import RegisterForm from '../../components/form/RegisterForm';
import logoU from '../../assets/images/logou-form.png';
import imgDateSalon from '../../assets/images/dates.png';
import imgHoraires from '../../assets/images/horaires.svg';
import imgSchool from '../../assets/images/school.svg';
import imgGaspi from '../../assets/images/geste-zero-gaspi.png';
import styles from './register.module.scss';
import content, { URL_FORMATIONS } from '~/constants';

const Register = () => {
  const { type } = useParams();
  if (!type || !['collaborateur', 'magasin', 'fournisseur'].includes(type)) {
    return <Navigate to='/login' />;
  }

  return (
    <div className={styles.register}>
      <div className={styles.infos}>
        <div className={styles.header}>
          <Link to="/" className={styles.logo}>
            <img src={logoU} alt='Coopérative U' />
          </Link>
          <div className={styles.logoDates}>
            <img src={imgDateSalon} alt='Coopérative U' />
          </div>
        </div>
        <div className={styles.content}>
          <section className={styles.horaires}>
            <img src={imgHoraires} alt='Coopérative U' />
            <p>
              <span className={styles.label}>LES HORAIRES&nbsp;:</span><br />
              {content.day1.day} : {content.day1.hours}<br />
              {content.day2.day} : {content.day2.hours}
            </p>
            {type === 'fournisseur' && (
              <p className={styles.fournisseurMention}>
                *L&apos;accès au salon se fait à partir de 7H30.
              </p>
            )}
          </section>
          <section className={styles.antiGaspi}>
            <div className={styles.antiGaspiContainer}>
              <img src={imgGaspi} alt='Coopérative U' />
              <p className={styles.antiGaspiTexte}>
                1 repas commandé<br/>
                = 1 repas consommé
              </p>
            </div>
            <p>
              Je change d&apos;avis ?
              <br/>Je modifie ma présence au repas
            </p>
          </section>
          {type === 'magasin'
            && <section>
              <a
                href={URL_FORMATIONS}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.formations}
              >
                  <img src={imgSchool} alt='Coopérative U' />
                  S&apos;inscrire aux formations
                  <br/>
                  (Inscription via UniSvers)
              </a>
            </section>
          }
        </div>
      </div>
      <div className={styles.form}>
        <RegisterForm />
      </div>
    </div>
  );
};

export default Register;
